import React from "react";
import ProfilePlaceholder from "assets/icons/teleconsult-user-placeholder.svg";
import DependentPlaceholder from "assets/icons/teleconsult-dependent-placeholder.svg";
import IconVideo from "assets/icons/teleconsult-video-icon.svg";
import IconChat from "assets/icons/teleconsult-chat-icon.svg";

import { getPatientInitials } from "helpers/teleconsult.helper";

function ProfileImage({ chat, icon }) {
  const placeholderImage = (e) => {
    if (chat.appointment_info && !chat.appointment_info?.is_me) {
      return DependentPlaceholder;
    } else {
      return ProfilePlaceholder;
    }
  };

  const SessionType = ({ chat }) => {
    if (chat.video_session) {
      return (
        <div>
          <div className="row m-0 notification">
            <img src={IconVideo} alt="video-icon" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="notification">
          <img src={IconChat} alt="chat-icon" />
        </div>
      );
    }
  };

  if (chat.anonymous || chat.payment.payer.avatar === null) {
    return (
      <>
        <div className="rounded-circle profile-image">
          {getPatientInitials(chat)}
        </div>
        {icon === true && <SessionType chat={chat} />}
      </>
    );
  } else {
    return (
      <>
        <img
          src={chat.payment.payer.avatar.thumb.url}
          className="rounded-circle profile-image"
          alt="profile-img"
          onError={(e) => {
            e.target.src = placeholderImage();
          }}
        />
        {icon === true && <SessionType chat={chat} />}
      </>
    );
  }
}

export default ProfileImage;
